<div>
  @if (type() === 'mat-text-button') {
    <button
      #btnEl
      mat-button
      disableRipple
      [ngClass]="{ '!shadow-inner-sm': isPressed() }"
      [class]="customButtonClass() + ' sakura-text-button '"
      (click)="onButtonClick($event)"
      [attr.role]="role()"
      [disabled]="disabled()"
      [attr.aria-label]="ariaLabel()"
    >
      <ng-container *ngTemplateOutlet="buttonTemplate"></ng-container>
    </button>
  } @else if (type() === 'mat-outlined-button') {
    <button
      #btnEl
      mat-stroked-button
      disableRipple
      [ngClass]="{ '!shadow-inner-sm': isPressed() }"
      [class]="customButtonClass() + ' sakura-outlined-button '"
      (click)="onButtonClick($event)"
      [disabled]="disabled()"
      [attr.aria-label]="ariaLabel()"
    >
      <ng-container *ngTemplateOutlet="buttonTemplate"></ng-container>
    </button>
  } @else if (type() === 'mat-warning-button') {
    <button
      #btnEl
      mat-stroked-button
      disableRipple
      [ngClass]="{ '!shadow-inner-sm': isPressed() }"
      [class]="
        customButtonClass() +
        ' sakura-warning-button ![background:--color-background-warning-dark] !text-[--color-text-warning] !border-none !font-bold disabled:opacity-50'
      "
      (click)="onButtonClick($event)"
      [disabled]="disabled()"
      [attr.aria-label]="ariaLabel()"
    >
      <ng-container *ngTemplateOutlet="buttonTemplate"></ng-container>
    </button>
  } @else if (type() === 'mat-filled-button') {
    <button
      #btnEl
      mat-flat-button
      disableRipple
      [ngClass]="{ '!shadow-inner-sm': isPressed() }"
      [class]="
        customButtonClass() +
        ' sakura-filled-button ' +
        bgColorClass() +
        ' !text-[--color-text-button] disabled:opacity-50'
      "
      (click)="onButtonClick($event)"
      [disabled]="disabled()"
      [attr.aria-label]="ariaLabel()"
    >
      <ng-container *ngTemplateOutlet="buttonTemplate"></ng-container>
    </button>
  } @else if (type() === 'mat-tonal-button') {
    <button
      #btnEl
      mat-flat-button
      disableRipple
      [ngClass]="{ '!shadow-inner-sm': isPressed() }"
      [class]="customButtonClass() + ' sakura-tonal-button '"
      (click)="onButtonClick($event)"
      [attr.role]="role()"
      [disabled]="disabled()"
      [attr.aria-label]="ariaLabel()"
    >
      <ng-container *ngTemplateOutlet="buttonTemplate"></ng-container>
    </button>
  }
</div>
<ng-template #buttonTemplate>
  <div [ngClass]="{ relative: loading() }" class="flex justify-center items-center">
    @if (loading()) {
      <div
        class="inline-block h-6 w-6 animate-spin rounded-full border-3 border-solid border-current border-r-transparent motion-reduce:animate-[spin_1.5s_linear_infinite] mr-1"
        role="status"
      ></div>
    }
    <p [ngClass]="customButtonTextClass()" class="flex items-center">
      @if (svg()) {
        <lib-svg [class]="svgClass()" [ngClass]="{ 'mr-2': text() }" [svg]="svg()"></lib-svg>
      }
      @if (text()) {
        {{ text() }}
      }
    </p>
  </div>
</ng-template>
